export default __webpack_public_path__ + "static/media/hiper.b0eddd5e.svg";